import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_mst_item_hdr_RowClass} from '../../../dbschema/bl_inv_mst_item_hdr.model';

export class InventoryItemHeaderContainerModel extends BaseContainerModel {
  bl_inv_mst_item_hdr: bl_inv_mst_item_hdr_RowClass = new bl_inv_mst_item_hdr_RowClass();
}

